import { definePreset } from '@primeng/themes'
import Aura from '@primeng/themes/aura'

export const PrimeNgCustomPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{my.primitive.cyan.50}',
      100: '{my.primitive.cyan.100}',
      200: '{my.primitive.cyan.200}',
      300: '{my.primitive.cyan.300}',
      400: '{my.primitive.cyan.400}',
      500: '{my.primitive.cyan.500}',
      600: '{my.primitive.cyan.600}',
      700: '{my.primitive.cyan.700}',
      800: '{my.primitive.cyan.800}',
      900: '{my.primitive.cyan.900}',
      950: '{my.primitive.cyan.950}',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{my.primitive.grey.50}',
          100: '{my.primitive.grey.100}',
          200: '{my.primitive.grey.200}',
          300: '{my.primitive.grey.300}',
          400: '{my.primitive.grey.400}',
          500: '{my.primitive.grey.500}',
          600: '{my.primitive.grey.600}',
          700: '{my.primitive.grey.700}',
          800: '{my.primitive.grey.800}',
          900: '{my.primitive.grey.900}',
          950: '{my.primitive.grey.950}',
        },
      },
      dark: {
        surface: {
          0: '#000000',
          50: '{my.primitive.grey.950}',
          100: '{my.primitive.grey.900}',
          200: '{my.primitive.grey.800}',
          300: '{my.primitive.grey.700}',
          400: '{my.primitive.grey.600}',
          500: '{my.primitive.grey.500}',
          600: '{my.primitive.grey.400}',
          700: '{my.primitive.grey.300}',
          800: '{my.primitive.grey.200}',
          900: '{my.primitive.grey.100}',
          950: '{my.primitive.grey.50}',
        },
      },
    },
  },
  components: {
    select: {
      option: { focusBackground: '{my.primitive.cyan.50}' },
    },
    dialog: {
      root: {
        borderColor: 'my.semantic.toolbar.primary.background',
      },
      content: {
        padding: '1.25rem',
      },
      header: {
        padding: '0.75rem 1.25rem',
      },
      css: ({ dt }) => `
        .p-dialog-header {
          background-color: ${dt('my.semantic.toolbar.primary.background')};
          border-radius: ${dt('dialog.border.radius')} ${dt('dialog.border.radius')} 0 0;
        }
        `,
    },
    toast: {
      css: () => `
        @media (max-width: 768px) {
          .p-toast {
            width: 33vw;
            min-width: 250px;
          }
        }
      `,
    },
    toolbar: {
      root: {
        padding: '0.6rem',
      },
    },
    drawer: {
      content: {
        padding: '{overlay.modal.padding}',
      },
      css: ({ dt }) => `
        .p-drawer-header {
          background-color: ${dt('my.semantic.toolbar.secondary.background')};
        }
        `,
    },
    fieldset: {
      css: () => `.p-fieldset {
        min-width: 0;
        max-width: 100%;
        width: 100%;
      }
      .p-fieldset-content-container {
        display: block;
      }`,
    },
    datatable: {
      css: () => `.p-datatable-tfoot {
        margin-top: 0.5rem;
      }`,
    },
    treetable: {
      css: () => `.p-treetable-tbody tr[role="row"] {
        --_d: clamp(var(--depth, 0), 0, 20);
        --saturation-factor: calc(1 - var(--_d) * 0.4);
        background: color-mix(
          in srgb,
          var(--prime-surface-100) calc(var(--saturation-factor) * 100%),
          var(--prime-surface-0)
        );
      }`,
    },
  },
  // Custom global design tokens
  extend: {
    my: {
      primitive: {
        cyan: {
          50: '#d6f5f4',
          100: '#adebea',
          200: '#83e2df',
          300: '#5ad8d5',
          400: '#46d3cf',
          500: '#31ceca',
          600: '#2bb5b2',
          700: '#27a5a2',
          800: '#1d7c79',
          900: '#145251',
          950: '#0a2928',
        },
        grey: {
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}',
        },
      },
      semantic: {
        toolbar: {
          primary: {
            background: '{primary.200}',
            border: '{primary.300}',
          },
          secondary: {
            background: '{primary.100}',
            border: '{primary.200}',
          },
          tertiary: {
            background: '{primary.50}',
            border: '{primary.100}',
          },
        },
      },
    },
  },
})
